import { css } from 'emotion';
import {
	grey,
	pink,
	darkGrey,
	headingXLarge,
	museo900,
	desktopMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const wrapperStyle = css({
	padding: '40px 0',
});

export const linksStyle = css({
	'& a': {
		color: pink,
	},
});

export const errorCodeStyle = css({
	...museo900,
	color: darkGrey,
	fontSize: '18px',
	lineHeight: '18px',
	marginBottom: '64px',
});

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
});

export const errorHelpStyle = css({
	color: grey,
	fontSize: '16px',
	lineHeight: '22px',
	maxWidth: '715px',
	marginBottom: '18px',
});

export const bodyStyle = css({
	color: grey,
	fontSize: '16px',
	lineHeight: '22px',
	maxWidth: '715px',
	marginBottom: '18px',
});

export const titleStyle = headingXLarge;



// WEBPACK FOOTER //
// ./src/page-styles/static/index.js